import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import type { IFormData } from 'Types/aemui/lead-form/aemuiLeadForm';

export const LeadServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl,
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey
	}
});

class LeadFormService {
	axiosInstance: AxiosInstance = LeadServiceAxiosInstance;

	submitForm(formData: IFormData): AxiosPromise<IFormData> {
		return this.axiosInstance.post('proc/leads/v1/new', formData);
	}
}

export const leadFormService = new LeadFormService();
